import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import ListProducts from './ListProducts';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import HappyHourScreen from './happyHour';
import ExecutivemenuScreen from './executiveMenu';
import BarScreen from './bar';
import { useSelector } from 'react-redux';
import DetailProduct from './DetailProduct';
import MotherScreen from './mother';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change, getInitData} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showMother, setShowMother] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [appetizers, setappetizers] = useState(false);
     const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [carnte, setcarnte] = useState(false);
    const [dataDrink, setdataDrink] = useState(false);
    const [dataCarne, setdataCarne] = useState(false);

     const {
       goHomeInit
     } = useSelector((state) => state.initLoad);
    
    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;
           
            setMenus(data);
        });
    }, [change]);


      useEffect(() => {
            menus.map((item) => {
                if (item.id === 479) {
                    setdrinks(item);
                    
                }
                if (item.id === 462) {
                    setappetizers(item);
                }
                 if (item.id === 469) {
                    setcarnte(item);
                }
            });
      }, [menus]);
    
    
     useEffect(() => {
         if (carnte) {
             carnte.menus.map((item) => {
                 if (item.id === 4375) {
                  setdataCarne(item)
                
               }
           })
       }
     }, [carnte]);
    
     useEffect(() => {
         if (drinks) {
             drinks.menus.map((item) => {
                 if (item.id === 4374) {
                     setdataDrink(item)
                     
                
               }
           })
       }
     }, [drinks]);
    
    
    useEffect(() => {
        console.log(goHomeInit, 'q mas qlq')
         setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
        setshowCategories(false)
        setShowDetailProduct(false)
    }, [goHomeInit]);
    


    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };

    
    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowListProduct(false);
            setShowSpecials(false)
            setShowHappy(false)
            SetshowExecutiveMenu(false)
            setShowBar(false)
            setshowCategories(false)
            getInitData()

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);

    

    return (
        <LayoutContent showBack={false} showImageTop={true} setShowSpecials={() => {
            setdishs(drinks)
            setShowListProduct(true)
        }} goCategories={setshowCategories}>
            <div>
                <div style={{ width: '100%' }}>
                    <img
                        style={{
                            width: 490,
                            height: 170,
                            justifyContent: 'center',
                            objectFit: 'contain',
                            zIndex: 100,
                            alignSelf: 'center',
                            marginTop: -80,
                            marginBottom: -30
                            
                        }}
                        src={require('./assets/logo.png')}
                    />
                </div>
                <div style={{ display: 'flex', width: '100%',  position: 'relative', zIndex: 100,  paddingInline: 20, boxSizing: 'border-box' }}>
                       
                    <div style={{ width: '50%'}}>
                        <video
                             onClick={() => {
                                setDataDish({ dish: dataCarne, alldish: carnte.menus})
                                setShowDetailProduct(true)
                            }}
                            src={require('./assets/brasa.mp4')}
                            loop autoPlay={true} muted 
                            style={{
                                width: '100%',
                                height: 509,
                                objectFit: 'contain',
                                borderRadius: 14,
                               
                            }}
                        />

                    </div>
                    <div style={{ width: '50%'}}>

                        <video
                             onClick={() => {
                                setdishs(appetizers)
                                setShowListProduct(true)
                            }}
                             loop autoPlay={true} muted 
                                style={{
                                    width: 300,
                                    height: 245,
                                    objectFit: 'cover',
                                    borderRadius: 14,
                                    marginTop: 5
                                }}
                                src={require('./assets/27_final.mp4')}
                        />
                        
                        <video
                            muted
                            loop
                            autoPlay
                            onClick={() => {
                                 setDataDish({ dish: dataDrink, alldish: drinks.menus})
                                 setShowDetailProduct(true)
                                //setShowMother(true)
                            }}
                            style={{
                                      marginTop: 7,
                                    width: 300,
                                    height: 245,
                                    objectFit: 'cover',
                                    borderRadius: 14,
                                }}
                                src={require('./assets/drinks.mp4')}
                            />
                    </div>
                </div>
               
            </div>

            <div
                onClick={()=>setshowCategories(true)}
                style={{
                    width: '100%',
                    alignItems: 'center',
                    paddingInline: 20,
                    boxSizing: 'border-box',
                    marginTop: 10
                }}>
                <img
                    src={require('./assets/banner.png')}
                    style={{
                        width: '100%',
                        height: 225,
                        objectFit: 'contain',
                        borderRadius: 15,
                        marginLeft: -20
                    }}
                />
            </div>

            {showListProduct && <ListProducts
                dishs={dishs}
                setShowListProduct={setShowListProduct}
            />}

            
            {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
            {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} />}
            {showHappy && <HappyHourScreen setShowHappy={setShowHappy} />}
            {showExecutiveMenu && <ExecutivemenuScreen SetshowExecutiveMenu={SetshowExecutiveMenu} />}
            {showBar && <BarScreen setShowBar={setShowBar} />}
            {showMother && <MotherScreen setShowMother={setShowMother} />}

            {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
            />}
            
            <img
                style={{
                    width: 180,
                    height: 180,
                    objectFit: 'contain',
                    borderRadius: 14,
                    position: 'absolute',
                    top: 1,
                    left: -52,
                }}
                src={require('./assets/item1.png')}
      />

      <img
        style={{
          width: 180,
          height: 180,
          objectFit: 'contain',
          borderRadius: 14,
          position: 'absolute',
          top: 1,
          right: -49,
        }}
        src={require('./assets/item2.png')}
      />
      <img
        style={{
          width: 280,
          height: 180,
         objectFit: 'contain',
          borderRadius: 14,
          position: 'absolute',
          left: 0,
          bottom: -6,
        }}
        src={require('./assets/item3.png')}
      />
            
        </LayoutContent>
    );
}

export default Index;